import React, { useEffect } from 'react'
import { v4 as uuidv4 } from 'uuid'

import { ItemProps } from '@/components/Form/types'
import Button from '@/components/UiElements/Button'
import Form from '@/components/Form'
import items from '../forms/style'



export default function FontStylesForm(props: ItemProps) {


	if (!props) return null
	const disabled = !props.formData.fontFamily


	const formRef = React.useRef<any>(null)
	const [updateFlag, setUpdateFlag] = React.useState<boolean>(false)



	useEffect(() => {
		const hasDefaultValue = props.formData.fontStyle?.find((item: any) => item.selected)
		if (hasDefaultValue) {
			formRef.current?.setData(hasDefaultValue)
			setUpdateFlag(true)
		} else {
			formRef.current?.setData({})
			setUpdateFlag(false)
		}
	}, [props])



	const handleAddRule = async () => {
		const validation = await formRef.current?.validate() || false

		if (!validation) {
			const data = await formRef.current?.getData() || {}
			const item = {
				...data,
				id: data.id || uuidv4(),
				selected: false,
			}

			const currentList = props.formData.fontStyle || []
			let newList

			if (updateFlag) {
				newList = currentList.map((i: any) => i.id === item.id ? item : i)
			} else {
				newList = [...currentList, item]
			}
			props?.onChange?.("fontStyle", newList)
		}


	}



	return (
		<div className={`flex flex-col gap-xl  relative rounded-md p-md mb-lg transition-all duration-500 overflow-hidden bg-gray-100`}>
			{
				disabled &&
				<div className="absolute inset-0 bg-gray-100 bg-opacity-50 z-10 flex items-center justify-center rounded-md"/>
			}

			<div className="grid grid-cols-12 gap-md"  >
				<Form
					ref={formRef}
					items={items}
				/>
			</div>
			<div>
				<Button
					size="sm"
					type="alt"
					className="pr-lg col-span-2 !justify-start"
					icon="+"
					onClick={handleAddRule}
				>
					{updateFlag ? "Update Style" : "Add Style" }
				</Button>
			</div>
		</div>
	)
}